module.exports = __webpack_public_path__ + "static/media/money-pence-one.d2caa15b.svg";